<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      南山站<br>
站点介绍<br>
南山站位于南山大道与桂庙路(滨海大道)的交叉路口，沿桂庙路至滨海大道布置。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:12	00:20	11号线	4分钟	6分32秒<br>
碧头	06:38	23:48	11号线	4分钟	6分32秒<br>
左炮台东	06:19	23:15	12号线	4分钟	8分钟<br>
海上田园东	06:32	00:28	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:12	00:20	11号线	4分34秒	6分钟<br>
碧头	06:38	23:48	11号线	4分34秒	6分钟<br>
左炮台东	06:23	23:15	12号线	8分钟	8分钟<br>
海上田园东	06:34	23:57	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:12	00:20	11号线	4分37秒	6分钟<br>
碧头	06:38	23:48	11号线	4分37秒	6分钟<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
桂庙路南侧、南光路、南光村、向南小学、南山派出所<br><br>
D出入口:<br>
南山大道东（南）侧、桂庙路南（东）侧、德道智能口腔中心、深圳鹏爱医疗美容医院、麦芽口腔南山机构<br><br>
E出入口:<br>
学府路、桂庙路北（东）侧、南山大道东（北）侧<br><br>
H出入口:<br>
桂庙路北、南山大道西侧<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 深坑工业区站<br>
8路、M229路、M266路、高峰专线29号<br><br>
C出入口:<br>
公交站名： 中海大山地站<br>
M324路<br><br>
D出入口:<br>
公交站名： 六约新村东站<br>
M229路、M266路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>